/**
 * 会员信息
 */
import React from 'react';
import { Input, Row, Col, Icon, Tooltip, Button, DatePicker, Select } from 'antd';
import moment from 'moment';
import PageLayout from '../../ui/PageLayout';
import MarketRentEdit from './MarketRentEdit';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import {getBase64} from '../../../util/util.js';
import Loading from '../../ui/Loading';
import { global_data } from '../../ui/auth'

class MarketRentIndex extends React.Component {

    columns = [
    //     {
    //     title: '所属市场',
    //     dataIndex: 'orgName',
    //     width: '10%',
    // }, 
    {
        title: '商户名称',
        dataIndex: 'contractName',
        width: '15%',
    }
    , {
        title: '租金',
        dataIndex: 'totalRentFees',
        width: '10%',
    }
    , {
        title: '租金状态',
        dataIndex: 'rentStatus',
        width: '6%',
        render: (text, record, index) => {
            let title = '未收费';
            let type = "close";
            if (text === 1) {
                title = '已收费';
                type = "check";
            } else if (text === 2) {
                title = '已审核';
                type = 'check-square';
            }
            return (
                <Tooltip title={title}>
                    <Icon type={type} className="table-operate-icon" />
                </Tooltip>
            )
        }
        // format: { 0: '未收费', 1: '已收费', 2: '已审核' }
    },{
        title: '物业费',
        dataIndex: 'totalPropertyFees',
        width: '10%',
    },{
        title: '物业费状态',
        dataIndex: 'propertyStatus',
        width: '6%',
        render: (text, record, index) => {
            let title = '未收费';
            let type = "close";
            if (text === 1) {
                title = '已收费';
                type = "check";
            } else if (text === 2) {
                title = '已审核';
                type = 'check-square';
            }
            return (
                <Tooltip title={title}>
                    <Icon type={type} className="table-operate-icon" />
                </Tooltip>
            )
        }
        // format: { 0: '未收费', 1: '已收费', 2: '已审核' }
    }, {
        title: '水费',
        dataIndex: 'waterFees',
        width: '10%',
    }
    , {
        title: '电费减免',
        dataIndex: 'deduction',
        width: '6%',
    }
    ,{
        title: '电费',
        dataIndex: 'electricityFees',
        width: '10%',
    }
    ,{
        title: '水电状态',
        dataIndex: 'electritictyStatus',
        width: '6%',
        render: (text, record, index) => {
            let title = '未收费';
            let type = "close";
            if (text === 1) {
                title = '已收费';
                type = "check";
            } else if (text === 2) {
                title = '已审核';
                type = 'check-square';
            }
            return (
                <Tooltip title={title}>
                    <Icon type={type} className="table-operate-icon" />
                </Tooltip>
            )
        }
        // format: { 0: '未收费', 1: '已收费', 2: '已审核' }
    }
    , {
        title: '广告费',
        dataIndex: 'totalAdvertiseFees',
        width: '10%',
    }
    , {
        title: '广告费状态',
        dataIndex: 'advertiseStatus',
        width: '6%',
        render: (text, record, index) => {
            let title = '未收费';
            let type = "close";
            if (text === 1) {
                title = '已收费';
                type = "check";
            } else if (text === 2) {
                title = '已审核';
                type = 'check-square';
            }
            return (
                <Tooltip title={title}>
                    <Icon type={type} className="table-operate-icon" />
                </Tooltip>
            )
        }
    }
    , {
        title: '停车费',
        dataIndex: 'totalBarrierFees',
        width: '10%',
    }
    , {
        title: '停车费状态',
        dataIndex: 'barrierStatus',
        width: '6%',
        render: (text, record, index) => {
            let title = '未收费';
            let type = "close";
            if (text === 1) {
                title = '已收费';
                type = "check";
            } else if (text === 2) {
                title = '已审核';
                type = 'check-square';
            }
            return (
                <Tooltip title={title}>
                    <Icon type={type} className="table-operate-icon" />
                </Tooltip>
            )
        }
    }
    ,{
        title: '合计',
        dataIndex: 'totalFees',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) =>
            (<div>
                 {
                    global_data.authCode.includes("MARKET_RENT_UPDATE")&&record.rentStatus === 0 && record.electritictyStatus === 0 && record.electritictyStatus===0 ?
                        <Tooltip title="修改">
                            <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                        </Tooltip>
                        : ''
                }
                {
                    global_data.authCode.includes("MARKET_RENT_COLLECT_RENT")&&record.rentStatus === 0 ?
                        <Tooltip title="租金完成收费">
                            <Icon type="money-collect" theme="filled" className="table-operate-icon" onClick={this.collectFees.bind(this, text, '1')} />
                        </Tooltip>
                        : ''
                }
                {
                    global_data.authCode.includes("MARKET_RENT_COLLECT_PROPERTY")&&record.propertyStatus === 0 ?
                        <Tooltip title="物业费完成收费">
                            <Icon type="money-collect" theme="filled" className="table-operate-icon" style={{ color: '#008000' }} onClick={this.collectFees.bind(this, text, '2')} />
                        </Tooltip>
                        : ''
                }
                {
                    global_data.authCode.includes("MARKET_RENT_COLLECT_WATERANDELE")&&record.electritictyStatus === 0 ?
                        <Tooltip title="水电完成收费">
                            <Icon type="money-collect" theme="filled" className="table-operate-icon" style={{ color: '#1890ff' }} onClick={this.collectFees.bind(this, text, '0')} />
                        </Tooltip>
                        : ''
                }
            </div>)
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {
            startDate: moment().month(moment().month() - 1).startOf('month').format("YYYY-MM"),
        },
        formula: {},
        loadingVisible: false
    };

    componentDidMount() {
        //获取电费计算公式
        http.post({
            url: "/tenantFees/findFeesFormula",
            data: {},
            success: (res) => {
                this.setState({ formula: res });
            }
        });
    }

    showModal = () => {
        this.setState({ visible: true });
    };
    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    createItem = () => {
        let month = this.state.queryData.startDate;
        let orgName = this.state.queryData.orgName;
        let orgCode = this.state.queryData.orgCode;
        orgName = (orgName == null || orgName == "") ? "全部市场" : orgName;    //eslint-disable-line
        messager.confirm("是否创建 " + month + " " + orgName + " 的收费条目？ 当月已创建了的商户不会再被创建。", () => {
            http.post({
                url: "/tenantFees/createTenantFees",
                data: { month: month, orgCode: orgCode },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("创建成功！");
                }
            });
        });
    }

    update = (info, e) => {
        info.elecFormula = this.state.formula.elecFormula;
        info.waterFormula = this.state.formula.waterFormula;
        this.setState({ editData: info });
        this.showModal();
    }

    //完成收费
    collectFees = (info, type, e) => {
        messager.confirm("是否提交完成该商户的收费？", () => {
            http.post({
                url: "/tenantFees/submitTenantFees",
                data: { id: info, type: type },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("操作成功！");
                }
            });
        });
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.memberName = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }
    queryMonthStart = (date, dateString) => {
        let { queryData } = this.state;
        queryData.startDate = dateString;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    selectChange = (value) => {
        let { queryData } = this.state;
        queryData.status = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    //选择文件上传
    uploadFile = (e) =>{
        this.setState({ loadingVisible: true });
        let file = e.target.files[0];
        getBase64(file).then(base64 => {
            http.post({
                url: '/tenantFees/uploadTenantFees',
                data: {
                    "fileName": file.name,
                    "file" : base64
                },
                success: (res) => {
                    this.setState({ loadingVisible: false });
                    messager.notify("上传成功！");
                    this.state.loadData(this.state.queryData)
                },
                error: (res) => {
                    messager.alert(res);
                    this.setState({ loadingVisible: false });
                }
            });
        });
        e.target.value=''
    }

    download = () =>{
        this.setState({ loadingVisible: true });
        http.download({
            url: '/tenantFees/downloadTenantFees',
            data: this.state.queryData,
            fileName: "租户收费信息.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="会员名称"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: 200 }}
                                />
                                <Select onChange={this.selectChange} allowClear={true} style={{ width: "100px", margin: '0 10px' }}>
                                    <Select.Option key={"0"}>未收费</Select.Option>
                                    <Select.Option key={"1"}>已收费</Select.Option>
                                    <Select.Option key={"2"}>已审核</Select.Option>
                                </Select>
                                <DatePicker.MonthPicker onChange={this.queryMonthStart} placeholder="月份"
                                    defaultValue={moment().month(moment().month() - 1).startOf('month')} allowClear={false} />
                                {global_data.authCode.includes("MARKET_RENT_IMPORT")?
                                    <Button type="primary" onClick={()=>{this.refs.fileInput.click()}} style={{"float":"right"}}>导入</Button>
                                :""}
                                {global_data.authCode.includes("MARKET_RENT_EXPORT")?
                                    <Button type="primary" onClick={this.download} style={{"margin":"0 10px", "float":"right"}}>导出</Button>
                                :""}
                                {global_data.authCode.includes("MARKET_RENT_ADD")?
                                    <Button type="primary" onClick={this.createItem} style={{"float":"right"}}>创建收费项</Button>
                                :""}
                                <input type="file" accept=".xlsx" onChange={this.uploadFile.bind(this)} style={{ display: "none" }} ref="fileInput" />
                            </Col>
                        </Row>
                    )}
                    initParams={this.state.queryData}
                    rowKey="id" url="/tenantFees/findTenantFeesPage" columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }); }}
                />
                <MarketRentEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                 <Loading visible={this.state.loadingVisible} message="正在处理中，请稍候..." />
            </div>
        )
    }
}

export default MarketRentIndex;